import { $api } from "@/lib/api";
import { keepPreviousData } from "@tanstack/react-query";
import type { MeetingMode } from "@/types/meetings";

export interface MeetingDateOptions {
  daysAhead?: number;
  daysBehind?: number;
}

export function useMeetingsQuery(
  mode: MeetingMode,
  backendToken?: string | null,
  options?: MeetingDateOptions
) {
  return $api.useQuery("get", "/api/v1/meetings", {
    params: {
      query: {
        mode,
        ...(options?.daysAhead !== undefined && { days_ahead: options.daysAhead }),
        ...(options?.daysBehind !== undefined && { days_behind: options.daysBehind }),
      },
    },
  }, {
    staleTime: 5 * 60 * 1000,
    placeholderData: keepPreviousData,
    enabled: !!backendToken,
    // Don't retry on token_expired -- the silent refresh handles recovery
    // and will invalidate+refetch once the fresh token is stored.
    retry: (failureCount, error) => {
      if (error instanceof Error && error.message.includes("token expired")) return false;
      return failureCount < 1;
    },
  });
}
